import { useEffect, useState } from 'react';

import { KaseApi } from '@/api';
import {
  /* MasterNameInvolvement, */ IKaseMasterName,
  MasterNameType,
} from '@/models';
import { useToastStore } from '@/store';

export const useDomesticRelatedNames = (kaseId: string) => {
  const [allOffenders, setAllOffenders] = useState<IKaseMasterName[]>([]);
  const [allWitnesses, setAllWitnesses] = useState<IKaseMasterName[]>([]);
  const [allVictims, setAllVictims] = useState<IKaseMasterName[]>([]);
  const [allRelatedNames, setAllRelatedNames] = useState<IKaseMasterName[]>([]);
  const { updateToast } = useToastStore();

  useEffect(() => {
    if (kaseId) {
      fetchRelatedMasterNames();
    }
  }, [kaseId]);

  const fetchRelatedMasterNames = async () => {
    try {
      const results = await KaseApi.getKaseMasterNames(String(kaseId));

      const data = results.data;
      const personsOnly = data.filter(
        (kmn: IKaseMasterName) =>
          kmn.masterName?.type === MasterNameType.PERSON,
      );

      setAllVictims(personsOnly);
      setAllOffenders(personsOnly);
      setAllWitnesses(personsOnly);
      setAllRelatedNames(personsOnly);
    } catch (err: any) {
      updateToast({ open: true, message: err.message });
    }
  };

  return { allOffenders, allWitnesses, allVictims, allRelatedNames };
};
